export default "__VITE_ASSET__DcWO1gam__"